import React from 'react';
import { Box, keyframes } from '@chakra-ui/react';

// Define the blinking animation
const blink = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
`;

const BlinkingCursor = () => {
  return (
    <Box
      as="span"
      bg="black"
      width="2px"
      height="1.5rem"
      display="inline-block"
      animation={`${blink} 1s steps(2) infinite`}
    />
  );
};

export default BlinkingCursor;
